import {
  GET_ARRANGEMENT,
  GET_ARRANGEMENT_SUCCESS,
  GET_ARRANGEMENT_FAILURE,
  REVIEW_PAYMENT,
  SUBMIT_PAYMENT,
  SUBMIT_PAYMENT_CONFIRMATION,
  RESET_PAYMENT,
} from '../actions/arrangement';

const INITIAL_STATE = { loading: true, submitting: false, cached: false };

export default function arrangementReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ARRANGEMENT:
      return {
        ...state,
        loading: true,
        // Synonymous with other reducers, to put it to cache as soon as requested
        cached: true,
      };
    case GET_ARRANGEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        arrangement: action.payload,
      };
    case GET_ARRANGEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // Merge review data, clear P2 for non-split flows
    case REVIEW_PAYMENT: {
      const isSplit = action.payload.isSplitPayment === true;
      return {
        ...state,
        confirm: null,
        error: null,
        review: {
          ...state.review,
          ...action.payload,
          isSplitPayment: isSplit,
          ...(!isSplit && { cpcDataPayment2: null }),
        },
      };
    }
    case SUBMIT_PAYMENT:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBMIT_PAYMENT_CONFIRMATION:
      return {
        ...state,
        submitting: false,
        review: null,
        confirm: action.payload,
      };
    case RESET_PAYMENT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
